import { render, staticRenderFns } from "./Boyner.vue?vue&type=template&id=7cd77279&scoped=true"
import script from "./Boyner.vue?vue&type=script&lang=js"
export * from "./Boyner.vue?vue&type=script&lang=js"
import style0 from "./Boyner.vue?vue&type=style&index=0&id=7cd77279&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd77279",
  null
  
)

export default component.exports